
<!-- {{result}-->
<zxing-scanner [autostart]="true" [(device)]="activeCamera" [enable]="scanEnable"
            [formats]="[11]" (scanSuccess)="scanSuccessed($event)"></zxing-scanner>